<li class="nav-item">
    <button class="btn btn-warning text-white me-2" (click)="postponeTurn()"><i class="fa fa-clock-o" aria-hidden="true"></i> {{ "postpone" | language }}</button>
</li>
